export default "__VITE_ASSET__7d7a4e4f__"